import { supabase } from '@/integrations/supabase/client';
import { authInterceptor } from '@/services/AuthInterceptorService';

/**
 * Wrapper simplifié pour les requêtes Supabase avec gestion automatique des erreurs d'authentification
 * Empêche les boucles infinies et gère le refresh automatique des tokens
 */
class SupabaseWrapper {
  /**
   * Wrapper pour les requêtes sur les tables (.from)
   */
  from(table: any) {
    // Retourner directement le query builder de Supabase avec interception
    const originalQuery = supabase.from(table);
    return originalQuery;
  }

  /**
   * Wrapper pour les fonctions RPC
   */
  rpc(functionName: any, params?: any) {
    const context = `rpc.${functionName}`;
    
    return authInterceptor.interceptRequest(
      () => supabase.rpc(functionName, params),
      context
    );
  }

  /**
   * Wrapper pour l'authentification (pas d'interception nécessaire)
   */
  get auth() {
    return supabase.auth;
  }

  /**
   * Wrapper pour le storage (pas d'interception nécessaire pour l'instant)
   */
  get storage() {
    return supabase.storage;
  }

  /**
   * Accès au client Supabase original (pour realtime, etc.)
   */
  get client() {
    return supabase;
  }

  /**
   * Méthode utilitaire pour exécuter une requête avec gestion d'erreur
   */
  async executeWithRetry<T>(
    requestFn: () => Promise<T>,
    context: string = 'manual'
  ): Promise<T> {
    return authInterceptor.interceptRequest(requestFn, context);
  }

  /**
   * Obtenir les statistiques de l'intercepteur
   */
  getInterceptorStats() {
    return authInterceptor.getStats();
  }
}

// Export de l'instance wrapper
export const supabaseWithAuth = new SupabaseWrapper();

// Export des utilitaires de détection d'erreur
export const { isAuthError, isNetworkError } = authInterceptor;